export function toSubmitDraftReportCaseLeadId(
  value: unknown,
): number | undefined {
  if (value == null || value === '') {
    return undefined;
  }
  const caseLeadId = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(caseLeadId) ? caseLeadId : undefined;
}
